export default __webpack_public_path__ + "static/media/twitter.94f47639.svg";